import MapAddress from "../../app/components/MapAddress/MapAddress";

export default function Contact() {
    return (
        <>
            <MapAddress />
        </>
    )
}